module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bwDgV"))).then(() => parcelRequire('37nVf'));